module.exports = __webpack_public_path__ + "img/notary-journal_B09KDW7W7V.d2671ed7.jpg";